import { useCallback, useEffect, useRef } from "react";
import { TriggeredHook } from "sonobello.utilities.react";

import { useObx } from "../../../hooks/useObx";
import ApiRequestPaths from "../../../constants/ApiRequestPaths";
import Reservation from "../../../types/Reservation";
import { ReservationRequestWithDistance } from "./useCreateReservation";

export interface IUseReleaseReservationProps {
  /** The id of the patient associated with the reservation to be released. */
  patientId: string;
  /** The id of the current session's contact. */
  contactId: string;
}

/** Handles the network requests necessary to release a held reservation for the OPS calendar process. */
const useReleaseReservation: TriggeredHook<void, Reservation, boolean, IUseReleaseReservationProps> = props => {
  const propsRef = useRef(props);

  useEffect(() => {
    propsRef.current = props;
  }, [props]);

  const { setReq, err, loading } = useObx<void, ReservationRequestWithDistance>("Release Reservation", {
    method: "post"
  });

  const execute = useCallback(
    (reservation: Reservation) =>
      setReq(
        r =>
          r && {
            ...r,
            url: ApiRequestPaths.postReservationUrlV1_1(
              propsRef.current.contactId,
              propsRef.current.patientId,
              reservation.center.id,
              reservation.service.id,
              reservation.slot.id
            ),
            payload: new ReservationRequestWithDistance(reservation.slot)
          }
      ),
    []
  );

  return { result: null, error: Boolean(err), isLoading: loading, execute };
};

export default useReleaseReservation;
